import { useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { XIcon } from "@phosphor-icons/react";

export type ToastProps = {
  message?: string;
  type?: "success" | "error" | "info";
  duration?: number;
  onClose: () => void;
};

const Toast: React.FC<ToastProps> = ({
  message,
  type = "success",
  duration = 3000,
  onClose,
}) => {
  useEffect(() => {
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [onClose, duration]);

  const typeStyles: Record<string, { bg: string; text: string; border: string }> = {
    success: {
      bg: "var(--raised)",
      text: "var(--ink)",
      border: "var(--glass-rim)"
    },
    error: {
      bg: "#fff1ecf2",
      text: "#8a2f1d",
      border: "#f1c7bb"
    },
    info: {
      bg: "var(--raised)",
      text: "var(--ink)",
      border: "var(--glass-rim)"
    },
  };

  const styles = typeStyles[type];

  return (
    <AnimatePresence>
      <motion.div
        initial={{ x: 50, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        exit={{ x: 100, opacity: 0 }}
        transition={{ type: "spring", stiffness: 300, damping: 25 }}
        className={`fixed px-4 py-2.5 rounded-xl flex items-center gap-3 z-50 glass text-[13px] ${
          type === "error" ? "top-5 right-5" : "bottom-5 right-5"
        }`}
        style={{
          background: styles.bg,
          color: styles.text,
          border: `1px solid ${styles.border}`,
          boxShadow: "0 12px 32px #1d334a29"
        }}
      >
        <span>{message}</span>
        <button onClick={onClose} style={{ color: styles.text }} aria-label="Dismiss">
          <XIcon size={16} />
        </button>
      </motion.div>
    </AnimatePresence>
  );
};

export default Toast;
